<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <!-- 条件搜索 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="8" :sm="24">
              <a-form-item label="昵称" prop="nickname">
                <a-input v-model="queryParam.nickname" placeholder="请输入昵称" allow-clear />
              </a-form-item>
            </a-col>

            <template v-if="advanced">
              <a-col :md="8" :sm="24">
                <a-form-item label="是否会员" prop="sex">
                  <a-select placeholder="请选择是否会员" v-model="queryParam.isVip" style="width: 100%" allow-clear>
                    <a-select-option :value="0">否</a-select-option>
                    <a-select-option :value="1">是</a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :md="8" :sm="24">
                <a-form-item label="用户id" prop="userId">
                  <a-input v-model="queryParam.userId" placeholder="请输入用户id" allow-clear />
                </a-form-item>
              </a-col>
              <a-col :md="8" :sm="24">
                <a-form-item label="用户邮箱" prop="email">
                  <a-input v-model="queryParam.email" placeholder="请输入用户邮箱" allow-clear />
                </a-form-item>
              </a-col>
              <a-col :md="8" :sm="24">
                <a-form-item label="订阅状态" prop="subscribeStatus">
                  <a-select placeholder="请选择订阅状态" v-model="queryParam.subscribeStatus" style="width: 100%" allow-clear>
                    <a-select-option :value="'0,1,3,7,8,9,11,12,13'">订阅中</a-select-option>
                    <a-select-option :value="'2,4,6,10,14'">未订阅</a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>

              <a-col :md="8" :sm="24">
                <a-form-item label="用户身份" prop="isGuest">
                  <a-select placeholder="请选择用户身份" v-model="queryParam.isGuest" style="width: 100%" allow-clear>
                    <a-select-option :value="1">注册用户</a-select-option>
                    <a-select-option :value="2">游客</a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :md="8" :sm="24">
                <a-form-item label="平台" prop="platform">
                  <a-select placeholder="请选择平台" v-model="queryParam.platform" style="width: 100%" allow-clear>
                    <a-select-option :value="`ios`">ios</a-select-option>
                    <a-select-option :value="`android`">android</a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
            </template>
            <a-col :md="!advanced && 8 || 24" :sm="24">
              <span class="table-page-search-submitButtons"
                :style="advanced && { float: 'right', overflow: 'hidden' } || {}">
                <a-button type="primary" @click="handleQuery"><a-icon type="search" />查询</a-button>
                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />重置</a-button>
                <a @click="toggleAdvanced" style="margin-left: 8px">
                  {{ advanced ? '收起' : '展开' }}
                  <a-icon :type="advanced ? 'up' : 'down'" />
                </a>
              </span>
            </a-col>
            <!--              <a-col :md="8" :sm="24">-->
            <!--                <a-form-item label="邀请码" prop="invitationCode">-->
            <!--                  <a-input v-model="queryParam.invitationCode" placeholder="请输入邀请码" allow-clear/>-->
            <!--                </a-form-item>-->
            <!--              </a-col>-->
            <!--              <a-col :md="8" :sm="24">-->
            <!--                <a-form-item label="是否推送" prop="isNotice">-->
            <!--                  <a-select placeholder="请选择是否推送" v-model="queryParam.isNotice" style="width: 100%" allow-clear>-->
            <!--                    <a-select-option v-for="(d, index) in dict.type.sys_notice_status" :key="index" :value="d.value">{{ d.label }}</a-select-option>-->
            <!--                  </a-select>-->
            <!--                </a-form-item>-->
            <!--              </a-col>-->
            <!--              <a-col :md="8" :sm="24">-->
            <!--                <a-form-item label="用户状态" prop="status">-->
            <!--                  <a-select placeholder="请选择用户状态" v-model="queryParam.status" style="width: 100%" allow-clear>-->
            <!--                    <a-select-option v-for="(d, index) in dict.type.sys_enable_disable" :key="index" :value="d.value">{{ d.label }}</a-select-option>-->
            <!--                  </a-select>-->
            <!--                </a-form-item>-->
            <!--              </a-col>-->
            <!--            </template>-->
            <!--            <a-col :md="!advanced && 8 || 24" :sm="24">-->
            <!--              <span class="table-page-search-submitButtons" :style="advanced && { float: 'right', overflow: 'hidden' } || {} ">-->
            <!--               -->
            <!--&lt;!&ndash;                <a @click="toggleAdvanced" style="margin-left: 8px">&ndash;&gt;-->
            <!--&lt;!&ndash;                  {{ advanced ? '收起' : '展开' }}&ndash;&gt;-->
            <!--&lt;!&ndash;                  <a-icon :type="advanced ? 'up' : 'down'"/>&ndash;&gt;-->
            <!--&lt;!&ndash;                </a>&ndash;&gt;-->
            <!--              </span>-->

            <!--            </a-col>-->
          </a-row>
        </a-form>
      </div>
      <!-- 操作 -->
      <div class="table-operations">

        <table-setting :style="{ float: 'right' }" :table-size.sync="tableSize" v-model="columns"
          :refresh-loading="loading" @refresh="getList" />
      </div>
      <!-- 增加修改 -->
      <create-form ref="createForm" :sexOptions="dict.type.sys_user_sex" :isNoticeOptions="dict.type.sys_notice_status"
        :statusOptions="dict.type.sys_enable_disable" @ok="getList" />
      <!-- 数据展示 -->
      <a-table :loading="loading" :size="tableSize" rowKey="id" :columns="columns" :data-source="list" :pagination="false"
        :bordered="tableBordered">
        <span slot="sex" slot-scope="text, record">
          <dict-tag :options="dict.type['sys_user_sex']" :value="record.sex" />
        </span>
        <span slot="isNotice" slot-scope="text, record">
          <dict-tag :options="dict.type['sys_notice_status']" :value="record.isNotice" />
        </span>


        <!-- <span slot="diamond" slot-scope="text, record">
          <a-input-number :min="0" :step="0" v-model="record.diamond" @keyup.enter="editDiamond(record)" />
        </span> -->


        <span slot="gradeLevel" slot-scope="text, record">
          <a-select style="width: 60%" @change="editLevel(record)" v-model="record.gradeLevel">
            <a-select-option :key="0">关闭分销</a-select-option>
            <!--            <a-select-option :key="1">一级用户</a-select-option>-->
            <!--            <a-select-option disabled :key="2">二级用户</a-select-option>-->
            <!--            <a-select-option disabled :key="3">三级用户</a-select-option>-->
            <!--            <a-select-option disabled :key="4">四级用户</a-select-option>-->
            <a-select-option :key="record.fitLevel" :value="record.fitLevel">
              {{ levelLabels[record.fitLevel] }}
            </a-select-option>
          </a-select>
        </span>
        <span slot="lastLogin" slot-scope="text, record">
          {{ parseTime(record.lastLogin) }}
        </span>
        <!-- <span slot="vipOverTime" slot-scope="text, record"> -->
          <!--          <div v-if="(record.vipOverTime && record.isVip == 1)">-->
          <!-- <a-date-picker v-model="record.vipOverTime" :format="YYYY - MM - DD" @change="editVipTime(record)" /> -->
          <!--            {{ parseTime(record.vipOverTime) }}-->
          <!--          </div>-->
          <!--          <div else >{ // '-' }}</div>-->
        <!-- </span> -->
        <span slot="operation" slot-scope="text, record">
          <a @click="showDetail(record)">
            <a-icon type="eye" />查看更多
          </a>
        </span>
      </a-table>
      <!-- 分页 -->
      <a-pagination class="ant-table-pagination" show-size-changer show-quick-jumper :current="queryParam.pageNum"
        :total="total" :page-size="queryParam.pageSize" :showTotal="total => `共 ${total} 条`"
        @showSizeChange="onShowSizeChange" @change="changeSize" :rowKey="(record, index) => index + 1" />
    </a-card>
    <a-modal v-model="detailVisible" title="用户详情" :footer="null" :width="600"
      :bodyStyle="{ maxHeight: '70vh', overflowY: 'auto' }" :style="{ top: '50px' }">
      <a-descriptions bordered column="1">
        <a-descriptions-item label="用户IP">{{ detailRecord.ip }}</a-descriptions-item>
        <a-descriptions-item label="用户地区">{{ detailRecord.address }}</a-descriptions-item>
        <a-descriptions-item label="平台">{{ detailRecord.platform }}</a-descriptions-item>
        <a-descriptions-item label="注册时间">{{ detailRecord.createTime }}</a-descriptions-item>
      </a-descriptions>
      <div style="height: 100px;"></div>
    </a-modal>

  </page-header-wrapper>
</template>

<script>
import { pageUser, listUser, delUser, editLevel, editVipTime, editDiamond } from '@/api/biz/user'
import CreateForm from './modules/CreateForm'
import { tableMixin } from '@/store/table-mixin'
import { editType } from "@/api/video/video";
import Vue from "vue";
import moment from "moment";

export default {
  name: 'User',
  components: {
    CreateForm
  },
  mixins: [tableMixin],
  dicts: ['sys_user_sex', 'sys_notice_status', 'sys_enable_disable'],
  data() {
    return {
      detailVisible: false,
      detailRecord: {}, // 存放当前详情记录
      levelLabels: {
        1: '一级用户',
        2: '二级用户',
        3: '三级用户'
      },
      list: [],
      selectedRowKeys: [],
      selectedRows: [],
      // 高级搜索 展开/关闭
      advanced: true,
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      ids: [],
      loading: false,
      total: 0,
      // 查询参数
      queryParam: {
        mobile: null,
        email: null,
        userId: null,
        isVip: null,
        nickname: null,
        sex: null,
        invitationCode: null,
        isNotice: null,
        status: null,
        pageNum: 1,
        pageSize: 10,
        subscribeStatus: null,
        isGuest: null,
        platform: null,
        startTime: null,
        endTime: null,
        isPay: null
      },

      subscribeStatusOptions: {
        [JSON.stringify([0, 1, 3, 7, 8, 9, 11, 12, 13])]: "订阅中",
        [JSON.stringify([2, 4, 6, 10, 14])]: "未订阅"
      },


      // subscribeStatusOptions: {
      //   0: "用户手动续费",
      //   1: "自动续费成功",
      //   2: "续费失败",
      //   3: "恢复续费",
      //   4: "用户取消自动续费",
      //   6: "退款",
      //   7: "升级",
      //   8: "待降级",
      //   9: "已降级",
      //   10: "暂停订阅",
      //   11: "保留订阅状态",
      //   12: "从保留状态恢复订阅",
      //   13: "重新订阅",
      //   14: "暂停订阅待生效"
      // },
      getSearchParams() {
        const statusMap = {
          active: [0, 1, 3, 7, 8, 9, 11, 12, 13],
          inactive: [2, 4, 6, 10, 14]
        };

        const statusValue = this.queryParam.subscribeStatus;
        return {
          ...this.queryParam,
          subscribeStatusList: statusValue ? statusMap[statusValue] : undefined
        };
      },

      columns: [
        // {
        //   title: '三方账号',
        //   dataIndex: 'mobile',
        //   align: 'center'
        // },
        {
          title: '序号',
          // ellipsis: true,,
          customRender: (text, record, index) => index + 1,
          width: '120',
          align: 'center'
        },
        {
          title: '用户ID',
          dataIndex: 'id',
          width: '120',
          align: 'center'
        },
        {
          title: '邮箱',
          dataIndex: 'email',
          width: '120',
          align: 'center'
        },
        {
          title: '昵称',
          dataIndex: 'nickname',
          width: '120',
          align: 'center',
          customRender: function (text) {
            if (text) {
              return text
            } else {
              return '-'
            }
          }
        },
        // {
        //   title: '邀请码',
        //   dataIndex: 'invitationCode',
        //   width: '120',
        //   align: 'center'
        // },
        {
          title: '金币余额',
          dataIndex: 'diamond',
          scopedSlots: { customRender: 'diamond' },
          align: 'center'
        },
        // {
        //   title: '是否开启分销',
        //   dataIndex: 'gradeLevel',
        //   scopedSlots: { customRender: 'gradeLevel' },
        //   align: 'center'
        // },
        // {
        //   title: '是否会员',
        //   dataIndex: 'isVip',
        //   width: '120',
        //   align: 'center',
        //   customRender: function (t, r, index) {
        //     if (t == 0) {
        //       return '否'
        //     } else if (t == 1) {
        //       return '是'
        //     }
        //   }
        // },
        // {
        //   title: '用户来源',
        //   dataIndex: 'type',
        //   width: '120',
        //   align: 'center',
        //   customRender: function (t, r, index) {
        //     if (t == 0) {
        //       return 'facebook'
        //     } else if (t == 1) {
        //       return 'goole'
        //     } else if (t == 2) {
        //       return 'apple'
        //     } else if (t == 3) {
        //       return 'tiktok'
        //     } else {
        //       return '未知'
        //     }
        //   }
        // },
        {
          title: '会员过期时间',
          dataIndex: 'vipOverTime',
          scopedSlots: { customRender: 'vipOverTime' },
          width: '120',
          align: 'center'
        },
        // {
        //   title: '金币数',
        //   dataIndex: 'gold',
        //   width: '120',
        //   align: 'center'
        // },
        // {
        //   title: '钻石数',
        //   dataIndex: 'diamond',
        //   width: '120',
        //   align: 'center'
        // },
        {
          title: '最后登录时间',
          dataIndex: 'lastLogin',
          scopedSlots: { customRender: 'lastLogin' },
          width: '120',
          align: 'center'
        },
        {
          title: '订阅状态',
          dataIndex: 'subscribeStatus',
          width: '120',
          align: 'center',
          customRender: function (subscribeStatus) {
            const activeStatusList = [0, 1, 3, 7, 8, 9, 11, 12, 13];
            const noActiveStatusList = [2, 4, 6, 10, 14];
            if (activeStatusList.includes(subscribeStatus)) {
              return "订阅中";
            } else if (noActiveStatusList.includes(subscribeStatus)) {
              return "取消订阅";
            } else {
              return "暂无订阅状态";
            }
          }
        },
        {
          title: '用户类型',
          dataIndex: 'isGuest',
          width: '120',
          align: 'center',
          customRender: function (t, r, index) {
            if (t == 1) {
              return '注册用户'
            } else if (t == 2) {
              return '游客'
            }
          }
        },
        {
          title: '操作',
          dataIndex: 'operation',
          width: '18%',
          scopedSlots: { customRender: 'operation' },
          align: 'center'
        }
      ]
    }
  },
  filters: {
  },
  created() {
    this.initQueryParamFromRoute()
    this.getList()
  },
  computed: {
  },
  watch: {
  },
  methods: {
    initQueryParamFromRoute() {
      console.log("==============",this.$route.query)
      const { startTime, endTime, subscribeStatus, isPay } = this.$route.query

      // 给 queryParam 赋值，同时做类型转换
      this.queryParam.startTime = startTime || null
      this.queryParam.endTime = endTime || null
      this.queryParam.subscribeStatus = subscribeStatus || null
      this.queryParam.isPay = isPay ? Number(isPay) : null
    },

    showDetail(record) {
      this.detailRecord = { ...record };
      this.detailVisible = true;
    },
    editLevel(record) {
      editLevel(record).then(response => {
        this.$message.success(
          '操作成功',
          3
        )
      })
    },

    editDiamond(record) {
      editDiamond(record).then(response => {
        this.$message.success(
          '操作成功',
          3
        )
      })
    },

    /** 查询用户信息列表 */
    getList() {
      this.loading = true
      if (moment.isMoment(this.queryParam.startTime)) {
        param.startTime = this.queryParam.startTime.format('YYYY-MM-DD')
      }
      if (moment.isMoment(this.queryParam.endTime)) {
        param.endTime = this.queryParam.endTime.format('YYYY-MM-DD')
      }
      pageUser(this.queryParam).then(response => {
        this.list = response.data.records
        console.log('后端返回数据：', response)
        this.total = response.data.total
        this.loading = false
      })
    },

    editVipTime(record) {
      if (moment.isMoment(record.vipOverTime)) {
        record.vipOverTime = record.vipOverTime.format('YYYY-MM-DD')
      }
      editVipTime(record).then(response => {
        this.$message.success(
          '操作成功',
          3
        )
        this.getList()
      })

    },

    /** 搜索按钮操作 */
    handleQuery() {
      this.queryParam.pageNum = 1
      this.getList()
    },
    /** 重置按钮操作 */
    resetQuery() {
      this.queryParam = {
        mobile: undefined,
        email: undefined,
        nickname: undefined,
        sex: undefined,
        invitationCode: undefined,
        isNotice: undefined,
        status: undefined,
        pageNum: 1,
        pageSize: 10,
        subscribeStatus: undefined
      }
      this.handleQuery()
    },
    onShowSizeChange(current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize(current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map(item => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    toggleAdvanced() {
      this.advanced = !this.advanced
    },
    /** 删除按钮操作 */
    handleDelete(row) {
      var that = this
      const ids = row.id || this.ids
      if (row.id) {
        this.ids.push(row.id)
      }
      this.$confirm({
        title: '确认删除所选中数据?',
        content: '当前选中编号为' + ids + '的数据',
        onOk() {
          const data = []
          that.ids.map(id => data.push({ 'id': id }))
          return delUser(data)
            .then(() => {
              that.onSelectChange([], [])
              that.getList()
              that.$message.success(
                '删除成功',
                3
              )
            })
        },
        onCancel() {
          // 取消清空删除ids列表
          that.ids = []
        }
      })
    },
    /** 导出按钮操作 */
    handleExport() {
      var that = this
      this.$confirm({
        title: '是否确认导出?',
        content: '此操作将导出当前条件下所有数据而非选中数据',
        onOk() {
          that.download('biz/user/export', {
            ...that.queryParam
          }, `用户信息_${new Date().getTime()}.xlsx`)
        },
        onCancel() { }
      })
    }
  }
}
</script>
